<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="免费领章信息" :width="1150" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit" @cancel="
        () => {
            emit('cancel')
        }
    ">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" scrollToFirstError v-bind="formLayout" :rules="rules" style="margin: 20px 0 100px 0">
                <a-form-item label="主体名称">
                    {{ props.customerData?.full_name }}
                </a-form-item>
                <a-form-item label="兑换码"> {{ state.detailData?.code }}</a-form-item>
                <a-form-item label="操作说明" v-if="state.detailData?.status == 0">
                    1点击右侧菜单【更多】->【一键刻章】；<br />2付款时选择对应的优惠券。</a-form-item>
                <a-form-item label="说明" v-else>已兑换</a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { useStore } from 'vuex'
const ruleForm = ref()
const rules = {}
const props = defineProps({
    open: {
        type: Boolean
    },
    customerData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['cancel'])
const formLayout = {
    labelCol: {
        xs: { span: 4 },
        sm: { span: 4 }
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 }
    }
}
interface state {
    loading: boolean
    detailData: any
}
const state = reactive<state>({
    loading: false,
    detailData: {
        dhm: '',
        status: 2
    }
})

onMounted(() => {
    queryDhm()
})
const queryDhm = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/customer/getZhangCoupon',
        method: 'post',
        data: { id: props.customerData.id }
    }
    baseService(requestParam)
        .then((res) => {
            state.detailData = res.data
            //复制文字到粘贴板
            handleCopyClick(`恭喜${props.customerData.full_name}获得免费兑换备案章一套的权益\r\n兑换码：${state.detailData.code}\r\n
兑换流程：电脑打开https://console.cskaiyela.com，点击右侧【更多】，点击【一键刻章】按钮，上传法人代表自拍照(不能身份证截图,不能生活艺术照，只能自拍照，不然章可能在未来（1个月2个月甚至是几个月后）某天巡查退回补材料，届时大家都没有时间去管这个事了，请一步到位)，提交订单,选择对应优惠券即可免费(减免${state.detailData.coupon_amout}元)领取。\r\n\r\n印章兑换提交成功后再无需任何操作，我公司每天都会去领章，领回后会和营业执照放一起邮寄走，如有特殊需求，请联系销售处理！\r\n`)
        }).catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('领取失败')
            }
        })
        .finally(() => {
            state.loading = false
        })
}
// 复制
const handleCopyClick = (val) => {
    var input = document.createElement('textarea')
    //将input的值设置为需要复制的内容
    input.value = val
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('已复制，可直接发给续费联系人!')
    //移除input标签
    document.body.removeChild(input)
}
const onFormSubmit = () => {
    emit('cancel')
}
</script>
<style lang="less" scoped>
.customer-options-popover {
    p {
        padding: 0 16px;
        margin: 0;
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        text-align: center;
        color: #000;
    }

    p:hover {
        color: var(--ant-primary-color);
        background: var(--ant-primary-color-deprecated-bg);
    }
}
</style>
